module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/other-kp/component/other-kp-main/other-kp-main-modal-customer/other-kp-main-modal-customer.component.sass
// module id = ./src/app/modules/other-kp/component/other-kp-main/other-kp-main-modal-customer/other-kp-main-modal-customer.component.sass
// module chunks = main